import React from 'react';
import PropTypes from 'prop-types';

const ChooseASurfaceOptionGroup = ({ children }) =>
  (<div className="flex-wrap-dependent-options dependent-options">{children}</div>);
;

ChooseASurfaceOptionGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ChooseASurfaceOptionGroup;
